// This file is generated by scripts/generate.mjs — do not edit.
// Source: svg/comment.svg
import { IconBase } from "./icon-base";
import type { IconProps } from "./types";

export function CommentIcon(props: IconProps) {
	return (
		<IconBase viewBox="0 0 16 16" {...props}>
			<path
				d="M14 8C14 4.68629 11.3137 2 8 2C7.23337 2 5.71627 2 4.39948 2C3.55966 2 3.13976 2 2.81893 2.16347C2.53671 2.30727 2.30727 2.53671 2.16347 2.81893C2 3.13976 2 3.55959 2 4.39925C2 5.65944 2 7.12061 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8Z"
				stroke="currentColor"
				strokeWidth="1.25"
				fill="none"
			/>
		</IconBase>
	);
}
